import { AppFormItem, AppFormItemProps, AppInput } from 'components/atoms';
import { formFields } from 'consts/form/formFields';
import { formElementRequiredText } from 'consts/errors/forms';
import { max300LengthRule } from 'consts/rules/textRules';

export const SupervisorInputElement = (props: AppFormItemProps) => (
    <AppFormItem
        label="Osoba nadzorująca"
        name={formFields.supervisor}
        rules={[{ required: true, message: formElementRequiredText }, max300LengthRule]}
        {...props}
    >
        <AppInput autoComplete="off" placeholder="Podaj osobę nadzorującą" />
    </AppFormItem>
);
